/*
 * @Descripttion:
 * @version:
 * @Author: 苏
 * @email: 1373842098@qq.com
 * @Date: 2022-06-30 11:14:14
 * @LastEditors: linxi
 * @LastEditTime: 2025-09-12 10:21:26
 */
import { unwrapResult } from '@reduxjs/toolkit'
import {
  Button,
  Checkbox,
  Col,
  Form,
  Input,
  notification,
  Radio,
  Row,
} from 'antd'
import React, { ReactElement, useContext, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../../../app/store'
import styles from '../../functionSettingTabs.module.css'
import _ from 'lodash'
import { selectSettings, selectTenant } from '../../../user/setting/settingSlice'
import { AnesthesiaMethodCategoryName, YJZSettingCategories } from '../../../../models/operation'
import { CloseOutlined } from '@ant-design/icons'
import { RecipeItemInput } from '../../../treatment/editor/components/RecipeItemInput'
import { ThemeContext } from '../../../../theme/ThemeContext'
import { getYJZChecksName, YJZCheckOptions, YJZChecks } from '../../../../models/MedicalTechnologyStationSetting'
import { geMTSSettingListAsync, getSubmitBatchAsync } from './MedicalTechnologyStationSettingSlice'

export const MedicalTechnologyStationSetting = (props: {
  selectedTab: any
}): ReactElement => {
  const [form] = Form.useForm()

  const settings = useSelector(selectSettings)

  const tenant = useSelector(selectTenant)

  const theme = useContext(ThemeContext)

  const dispatch = useDispatch<RootDispatch>()

  const [buttonLoading, setButtonLoading] = useState(false)

  const [value, setValue] = useState<any>()

  const [selectedName, setSelectedNames] = useState<any[]>([])

  const [data, setData] = useState<any>()

  const [kZXLXFlag, setKZXLXFlag] = useState<any>('3')

  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (props?.selectedTab == '10') {
      getDetail()
    }
  }, [props?.selectedTab])

  const getDetail = () => {
    setLoading(true)
    dispatch(geMTSSettingListAsync())
      .then(unwrapResult)
      .then((v: any) => {
        const data = v?.filter((item: any) => item?.itemCode == YJZChecks.SCGHSJ)
        setData(v)
        form.setFieldsValue({
          [YJZChecks.SCGHSJ]: data?.[0]?.configValue?.toString() || '3',
        })
        setKZXLXFlag(data?.[0]?.configValue?.toString() || '3')
        if (data?.[0]?.configValue == 1) {
          form.setFieldsValue({
            billCategoryItems: data?.[0]?.additionalInfo?.split(',') || [],
          })
        } else if (data?.[0]?.configValue == 2) {
          setSelectedNames(JSON.parse(data?.[0]?.additionalInfo))
        } else {
          setSelectedNames([])
        }
      })
      .catch(() => {
        form.setFieldsValue({
          [YJZChecks.SCGHSJ]: '3',
        })
        setKZXLXFlag('3')
      })
      .finally(() => {
        setLoading(false)
      })
  }

  return (
    <Col className={styles.MTSSetting}>
      <Form
        form={form}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
          }
        }}
        onFinish={(values) => {
          setButtonLoading(true)
          const selectNameList = selectedName?.map((item: any) => {
            return {
              id: item?.id,
              name: item?.name,
            }
          })
          const additionalInfo = values?.[YJZChecks.SCGHSJ] == '1' ? values?.billCategoryItems?.join(',') : values?.[YJZChecks.SCGHSJ] == '2' ? JSON.stringify(selectNameList) : ''
          const results = YJZCheckOptions?.map((v) => {
            return {
              additionalInfo: additionalInfo,  // 所有选中的用户ID（逗号分隔）
              configValue: values[v],  // 配置值
              id: data?.filter((item: any) => item?.itemCode == v)?.[0]?.id,
              itemCode: v,
              itemName: getYJZChecksName(v),
            }
          })
          dispatch(getSubmitBatchAsync(results))
            .then(unwrapResult)
            .then(() => {
              notification.success({
                message: '保存成功',
              })
              getDetail()
            })
            .catch(() => {
              notification.error({
                message: '保存失败',
              })
            })
            .finally(() => {
              setButtonLoading(false)
            })
        }}
      >
        <div style={{ overflow: 'auto', height: 'calc(100% - 40px)' }}>
          <div>
            <Col className={styles.rowHeight} span={24}>
              <Form.Item label='可执行类型' name={YJZChecks.SCGHSJ}>
                <Radio.Group defaultValue={'3'}
                  onChange={((v) => {
                    setKZXLXFlag(v?.target?.value)
                    form.setFieldsValue({
                      [YJZChecks.SCGHSJ]: v?.target?.value,
                    })
                  })}>
                  <Radio value={'1'}>按开票项目</Radio>
                  <Radio value={'2'}>按具体诊疗</Radio>
                  <Radio value={'3'}>不开启医技站执行</Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
            {kZXLXFlag == '1' ? (
              <Col className={styles.rowHeightCheckBox} span={24}>
                <Form.Item label='可执行开票项目' name='billCategoryItems'>
                  <Checkbox.Group>
                    <Row gutter={[8, 8]} style={{width:'80%'}}>
                      {YJZSettingCategories.map((item) => (
                        <Col style={{width:'20%'}} key={item}>
                          <Checkbox value={item} style={{ lineHeight: '26px'}}>{AnesthesiaMethodCategoryName(item)}</Checkbox>
                        </Col>
                      ))}
                    </Row>
                  </Checkbox.Group>
                </Form.Item>
              </Col>
            ) : kZXLXFlag == '2' ? <>
              <Col className={styles.rowHeight} span={24}>
                <Form.Item name='drugName' label='诊疗搜索'>
                  <RecipeItemInput
                    isRestrictUser={1}
                    style={{
                      width: '300px',
                      height: '2rem',
                      color: theme.tc1,
                    }}
                    placeholder='请输入诊疗项目'
                    autoFocus
                    type={2}
                    value={value}
                    onSelect={(v: any) => {
                      setValue('')
                      if (selectedName?.length >= 50) {
                        notification.info({
                          message: '最多选择50条',
                        })
                        form.resetFields(['drugName'])
                      } else {
                        if (
                          !selectedName.find((d) => d.id === v.id)
                        ) {
                          setSelectedNames(selectedName.concat(v))
                          form.resetFields(['drugName'])
                        }
                      }
                    }}
                    onChange={(v: any) => {
                      setValue(v)
                    }}
                  />
                </Form.Item>
              </Col>
              <Col
                style={{
                  borderRadius: 2,
                  padding: '10px 0 0 10px',
                  marginBottom: 10,
                  marginLeft: 140,
                  display: 'flex',
                  flexWrap: 'wrap',
                }}
              >
                {selectedName?.map((d: any) => (
                  <div key={d.id} className={styles.disease}>
                    {`${d.name}`}
                    <CloseOutlined
                      style={{ cursor: 'pointer', marginLeft: '6px' }}
                      onClick={() => {
                        setSelectedNames(
                          selectedName.filter(
                            (i: any) => i.id !== d.id
                          )
                        )
                      }}
                    />
                  </div>
                ))}
              </Col>
            </> : <></>}
          </div>
        </div>
        <Row style={{ paddingTop: '10px' }}>
          <Col span={12}>
            <Button
              htmlType='button'
              onClick={() => {
                getDetail()
                form.setFieldsValue({
                  billCategoryItems: '',
                  drugName: '',
                })
                setSelectedNames([])
              }}
              style={{
                float: 'right',
                marginRight: '10px',
              }}
            >
              取消
            </Button>
          </Col>
          <Col span={12}>
            <Button
              loading={buttonLoading}
              type='primary'
              style={{
                float: 'left',
              }}
              onClick={() => {
                form.submit()
              }}
            >
              保存
            </Button>
          </Col>
        </Row>
      </Form>
    </Col >
  )
}
